import { AxiosResponse } from 'axios';
import { useQuery } from '@tanstack/react-query';
import { AdvisoryResponse } from 'core/types/api/Api';
import ServerError from '../../errors/ServerError';
import SM from '../../services/ServiceManager';

export const usePostAdvisoryProcessData = ({
    contactGroupId, contactId, isEnabled = true,
}) => {
    const result = useQuery({
        queryKey: ['postAdvisoryProcessData', contactGroupId, contactId],
        enabled: !!contactGroupId && !!contactId && isEnabled,
        retry: false,
        queryFn: async () => {
            const response: AxiosResponse<AdvisoryResponse> = await SM.customAdvisoryServices(
                'generateAdvisoryEntity',
                [{ payload: { contactGroupId, contactId } }],
            );

            return response;
        },
    });

    return {
        ...result,
        data: result?.data?.data,
        statusCode: result?.data?.status,
        error: result.error ? new ServerError(result.error) : result.error,
    };
};
